export const buildUrl = (...args) => args.filter(Boolean).join('/')
  .replace('://', '***')
  .split('/')
  .filter(Boolean)
  .join('/')
  .replace('***', '://');
